"use client";

import type { MouseEvent, ReactNode } from "react";

type ScrollToBookingLinkProps = {
  hash: string;
  className?: string;
  children: ReactNode;
};

export default function ScrollToBookingLink({
  hash,
  className,
  children,
}: ScrollToBookingLinkProps): JSX.Element {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!hash.startsWith("#")) return;

    event.preventDefault();
    const targetId = hash.slice(1);
    const target = document.getElementById(targetId);
    if (!target) return;

    // Keep URL hash in sync while always forcing smooth scroll.
    const { pathname, search } = window.location;
    window.history.replaceState(null, "", `${pathname}${search}${hash}`);
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <a href={hash} onClick={onClick} className={className}>
      {children}
    </a>
  );
}
